import { _ as _defineProperty, a as _slicedToArray } from '../_chunks/dep-50ece1d9.js';
import { u as useApiProps, _ as _toConsumableArray } from '../_chunks/dep-f0ef67c3.js';
import { _ as _objectWithoutProperties } from '../_chunks/dep-06688d2c.js';
import React, { forwardRef, useState, useEffect, useCallback } from 'react';
import '../util/use-size-props.js';
import '../util/use-common-classname.js';
import '../util/use-config.js';

var _excluded = ["colors", "className", "id", "hover", "size", "disabled", "style", "color", "onMouseEnter", "onMouseLeave"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var WechatConfirmedIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$colors = props.colors,
    colors = _props$colors === void 0 ? [] : _props$colors,
    className = props.className,
    _props$id = props.id,
    id = _props$id === void 0 ? "" : _props$id,
    _props$hover = props.hover,
    hover = _props$hover === void 0 ? "" : _props$hover,
    size = props.size,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    style = props.style,
    color = props.color,
    onMouseEnter = props.onMouseEnter,
    onMouseLeave = props.onMouseLeave,
    resultProps = _objectWithoutProperties(props, _excluded);
  var _useApiProps = useApiProps({
      className: className,
      initColor: ["black", "#00A870", "white"],
      initName: "wechat-confirmed",
      colors: colors,
      id: id,
      hover: hover,
      size: size,
      style: style,
      disabled: disabled,
      color: color
    }),
    sizeStyle = _useApiProps.sizeStyle,
    cls = _useApiProps.cls;
  var _useState = useState(["black", "#00A870", "white"]),
    _useState2 = _slicedToArray(_useState, 2),
    colorList = _useState2[0],
    setColorList = _useState2[1];
  var _useState3 = useState(["black", "#00A870", "white"]),
    _useState4 = _slicedToArray(_useState3, 2),
    colorsProps = _useState4[0],
    setColorsProps = _useState4[1];
  var _useState5 = useState(["black", "#00A870", "white"]),
    _useState6 = _slicedToArray(_useState5, 2),
    defaultColor = _useState6[0],
    _ = _useState6[1];
  useEffect(function () {
    if (typeof colors === "string" && "wechat-confirmed".indexOf("-colored") === -1) {
      var col = JSON.parse(JSON.stringify(["black", "#00A870", "white"]));
      var find = col.find(function (item) {
        return item === "currentColor";
      });
      var _col = col;
      if (find) {
        _col = col.map(function (item) {
          if (item === "currentColor") {
            item = colors;
          }
          return item;
        });
      } else {
        _col[0] = colors;
      }
      setColorList(_col);
      setColorsProps(_col);
    }
    if (colors instanceof Array && "wechat-confirmed".indexOf("-colored") === -1) {
      var colorList1 = JSON.parse(JSON.stringify(["black", "#00A870", "white"]));
      colors.forEach(function (col) {
        var findColorIndex = colorList1.findIndex(function (v) {
          return v === col.targetColor;
        });
        if (findColorIndex >= 0) {
          colorList1[findColorIndex] = col.reviseColor;
        }
      });
      setColorList(_toConsumableArray(colorList1));
      setColorsProps(_toConsumableArray(colorList1));
    }
    if (color && typeof color === "string" && "wechat-confirmed".indexOf("-colored") === -1) {
      var _col2 = JSON.parse(JSON.stringify(["black", "#00A870", "white"]));
      var _find = _col2.find(function (item) {
        return item === "currentColor";
      });
      var _col3 = _col2;
      if (_find) {
        _col3 = _col2.map(function (item) {
          if (item === "currentColor") {
            item = color;
          }
          return item;
        });
      } else {
        _col3[0] = color;
      }
      setColorList(_col3);
      setColorsProps(_col3);
    }
  }, [JSON.stringify(colors), color, defaultColor]);
  var handleMouseEnter = useCallback(function (event) {
    onMouseEnter && onMouseEnter(event);
    if (!hover || hover.length === 0) return;
    if (colors instanceof Array && "wechat-confirmed".indexOf("-colored") === -1) {
      if (hover instanceof Array && "wechat-confirmed".indexOf("-colored") === -1) {
        var colorList1 = JSON.parse(JSON.stringify(colorList));
        hover.forEach(function (col) {
          var findColorIndex = colorList1.findIndex(function (v) {
            return v === col.targetColor;
          });
          if (findColorIndex >= 0) {
            colorList1[findColorIndex] = col.reviseColor;
          }
        });
        setColorList(_toConsumableArray(colorList1));
      }
    }
    if (typeof colors === "string" && "wechat-confirmed".indexOf("-colored") === -1) {
      if (typeof hover === "string") {
        var col = JSON.parse(JSON.stringify(colorList));
        var find = col.find(function (item) {
          return item === colors;
        });
        var _col = col;
        if (find) {
          _col = col.map(function (item) {
            if (item === colors) {
              item = hover;
            }
            return item;
          });
        } else {
          _col[0] = hover;
        }
        setColorList(_col);
      }
    }
    if (color && typeof color === "string" && "wechat-confirmed".indexOf("-colored") === -1) {
      if (typeof hover === "string") {
        var _col4 = JSON.parse(JSON.stringify(colorList));
        var _find2 = _col4.find(function (item) {
          return item === color;
        });
        var _col5 = _col4;
        if (_find2) {
          _col5 = _col4.map(function (item) {
            if (item === color) {
              item = hover;
            }
            return item;
          });
        } else {
          _col5[0] = hover;
        }
        setColorList(_col5);
      }
    }
    if (!color && colors.length === 0 && typeof hover === "string" && "wechat-confirmed".indexOf("-colored") === -1) {
      var _col6 = JSON.parse(JSON.stringify(colorList));
      var _find3 = _col6.find(function (item) {
        return item === "currentColor";
      });
      var _col7 = _col6;
      if (_find3) {
        _col7 = _col6.map(function (item) {
          if (item === "currentColor") {
            item = hover;
          }
          return item;
        });
      } else {
        _col7[0] = hover;
      }
      setColorList(_col7);
    }
    if (!color && colors.length === 0 && hover instanceof Array && "wechat-confirmed".indexOf("-colored") === -1) {
      var _colorList = JSON.parse(JSON.stringify(colorList));
      hover.forEach(function (col) {
        var findColorIndex = _colorList.findIndex(function (v) {
          return v === col.targetColor;
        });
        if (findColorIndex >= 0) {
          _colorList[findColorIndex] = col.reviseColor;
        }
      });
      setColorList(_toConsumableArray(_colorList));
    }
  }, [colorList, defaultColor, colors, color, hover]);
  var handleMouseLeave = useCallback(function (event) {
    onMouseLeave && onMouseLeave(event);
    if (!hover || hover.length === 0) return;
    var _defaultColor = JSON.parse(JSON.stringify(defaultColor));
    if (colorsProps) {
      _defaultColor = JSON.parse(JSON.stringify(colorsProps));
    }
    setColorList(_defaultColor);
  }, [colorsProps, defaultColor, hover]);
  return /* @__PURE__ */React.createElement("svg", _objectSpread(_objectSpread({
    id: "wechat-confirmed",
    style: sizeStyle,
    className: cls,
    ref: ref,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave
  }, resultProps), {}, {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16"
  }), /* @__PURE__ */React.createElement("g", {
    fill: "none"
  }, /* @__PURE__ */React.createElement("path", {
    d: "M0.825684 7.78439C0.825684 4.49519 3.90832 2 7.48248 2C10.8936 2 13.8547 4.2711 14.12 7.33755C13.6866 7.09586 13.2037 6.93241 12.6903 6.8663C12.1907 4.90621 10.1222 3.33333 7.48248 3.33333C4.44013 3.33333 2.15902 5.42071 2.15902 7.78439C2.15902 9.08961 2.83639 10.2906 3.96657 11.1239L4.31033 11.3773L4.06907 12.5434L5.41021 11.8908L5.6609 11.9674C6.22773 12.1404 6.84091 12.2355 7.48248 12.2355C7.79678 12.2355 8.10428 12.2127 8.40284 12.169C8.56291 12.621 8.80192 13.0356 9.10328 13.3963C8.58364 13.5091 8.04059 13.5688 7.48248 13.5688C6.80395 13.5688 6.14767 13.4806 5.52866 13.316L3.31321 14.3941H2.32461L2.83485 11.9279C1.61184 10.8917 0.825684 9.42953 0.825684 7.78439Z",
    fill: colorList[0],
    fillOpacity: "0.9"
  }), /* @__PURE__ */React.createElement("path", {
    d: "M5.37327 5.52441C4.90943 5.52441 4.5332 5.90044 4.5332 6.36448C4.5332 6.82865 4.90941 7.2047 5.37327 7.2047C5.83744 7.2047 6.21349 6.82865 6.21349 6.36448C6.21349 5.90044 5.83742 5.52441 5.37327 5.52441Z",
    fill: colorList[0],
    fillOpacity: "0.9"
  }), /* @__PURE__ */React.createElement("path", {
    d: "M9.57422 5.52441C9.11007 5.52441 8.734 5.90044 8.734 6.36448C8.734 6.82865 9.11005 7.2047 9.57422 7.2047C10.0382 7.2047 10.4144 6.82867 10.4144 6.36448C10.4144 5.90042 10.0382 5.52441 9.57422 5.52441Z",
    fill: colorList[0],
    fillOpacity: "0.9"
  }), /* @__PURE__ */React.createElement("path", {
    d: "M9.17432 10.8334C9.17432 9.17652 10.5175 7.83337 12.1743 7.83337C13.8312 7.83337 15.1743 9.17652 15.1743 10.8334C15.1743 12.4902 13.8312 13.8334 12.1743 13.8334C10.5175 13.8334 9.17432 12.4902 9.17432 10.8334Z",
    fill: colorList[1],
    fillRule: "evenodd",
    clipRule: "evenodd"
  }), /* @__PURE__ */React.createElement("path", {
    d: "M13.9681 10.1666L11.8412 12.2936L10.3809 10.8333L11.0078 10.2063L11.8412 11.0397L13.3412 9.53967L13.9681 10.1666Z",
    fill: colorList[2],
    fillRule: "evenodd",
    clipRule: "evenodd"
  })));
});
WechatConfirmedIcon.displayName = "WechatConfirmedIcon";

export { WechatConfirmedIcon as default };
//# sourceMappingURL=wechat-confirmed.js.map
